import axios from 'axios';
import { PageItemsFilter } from 'modules/spravochnik/dt-front-page-generator/src/Service/PageService/PageItemsFilter';
import { BasePageItem, PageItem } from 'modules/spravochnik/dt-front-page-generator/src/Entity/PageItem';
import { Category } from '../Entity/Category';
import { Slides, PageItemInterface } from '../Entity/index';
import { Page, PageIdentity } from '../Entity/Page';
import { Sort } from 'modules/spravochnik/dt-front-page-generator/src/Entity/Sort/Sort';
import ChunkCollection from "modules/spravochnik/dt-front-page-generator/src/Utils/ChunkCollection";

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-CSRF-TOKEN'] = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute('content');

class SpravochnikApi {
    async fetchCategories(): Promise<Array<Category>> {
        const response = await axios.get('/spravochnik/dt/ajax-category-list');
        const categories = [];
        for (const data of response.data) {
            categories.push(Category.createByObj(data));
        }

        return categories;
    }

    async getCategory(categoryUrlName: string): Promise<Category> {
        const response = await axios.get('/spravochnik/dt/ajax-category-view', {
            params: { 'categoryUrlName': categoryUrlName },
        });

        return Category.createByObj(response.data);
    }

    async getPage(pageIdentity: PageIdentity): Promise<Page> {
        const response = await axios.get('/spravochnik/dt/ajax-page-view', {
            params: {
                'categoryUrlName': pageIdentity.categoryUrlName,
                'pageUrlName': pageIdentity.pageUrlName,
            },
        });

        return Page.createByObj(response.data);
    }

    async getPageItem(pageIdentity: PageIdentity, id: string): Promise<PageItem> {
        const response = await axios.get('/spravochnik/dt/ajax-page-item', {
            params: {
                'categoryUrlName': pageIdentity.categoryUrlName,
                'pageUrlName': pageIdentity.pageUrlName,
                'itemId': id,
            },
        });

        return PageItem.createByObj(response.data);
    }

    async fetchPageItemByIds(page: Page, ids: string[]): Promise<Array<PageItemInterface>> {
        const response = await axios.get('/spravochnik/dt/ajax-page-items-by-ids', {
            params: {
                'categoryUrlName': page.identity.categoryUrlName,
                'pageUrlName': page.identity.pageUrlName,
                'ids': ids,
            },
        });

        const list = [];
        for (const item of response.data) {
            list.push(BasePageItem.createByObj(item));
        }

        return list;
    }

    async fetchPageItems(pageIdentity: PageIdentity, filter: PageItemsFilter, sort: Sort, pageNumber: number): Promise<ChunkCollection<PageItemInterface>> {
        const params = {
            categoryUrlName: pageIdentity.categoryUrlName,
            pageUrlName: pageIdentity.pageUrlName,
            filters: JSON.stringify(filter.filters),
            page: pageNumber,
        } as any;
        if (sort) {
            params.sortBy = sort.id;
        }

        const response = await axios.get('/spravochnik/dt/ajax-page-items', {
            params: params,
        });

        const list = [];
        for (const item of response.data.list) {
            list.push(BasePageItem.createByObj(item));
        }

        return new ChunkCollection(list, response.data.total);
    }

    async fetchAllPageItemsForCategory(categoryUrlName: string, ids: string[]): Promise<Array<PageItemInterface>> {
        const params = new URLSearchParams();
        params.append('categoryUrlName', categoryUrlName);
        params.append('ids', JSON.stringify(ids || []));

        const response = await axios.get('/spravochnik/dt/ajax-category-items-by-ids', {
            params: {
                categoryUrlName: categoryUrlName,
                ids: ids,
            },
        });
        const list = [];
        for (const item of response.data) {
            list.push(BasePageItem.createByObj(item));
        }

        return list;
    }

    async fetchSliders(): Promise<Slides> {
        const response = await axios.get('/spravochnik/dt/ajax-page-slider');

        return response.data.slides as Slides;
    }

    async fetchOpenDataCategories(): Promise<any> {
        const response = await axios.get('/spravochnik/dt/ajax-open-data-category-list');
        return response.data;
    }

    async getAjaxCategoryMap(categoryUrlName: string): Promise<any> {
        const response = await axios.get('/spravochnik/dt/ajax-category-map', {
            params: { 'categoryUrlName': categoryUrlName },
        });
        return response.data;
    }

    async fetchMapObjectByPage(page: Page): Promise<Array<object>> {
        const filter = new PageItemsFilter(page.filters);

        const params = {
            categoryUrlName: page.identity.categoryUrlName,
            pageUrlName: page.identity.pageUrlName,
            filters: JSON.stringify(filter.filters),
        } as any;

        const response = await axios.get('/spravochnik/dt/ajax-page-map', {
            params,
        });
        return response.data.objects;
    }

}

const Api = new SpravochnikApi();

export { Api };
